var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { TreeNode, TreeService } from '../tree/tree.service';
var ItemTreeService = /** @class */ (function (_super) {
    __extends(ItemTreeService, _super);
    function ItemTreeService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    ItemTreeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ItemTreeService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return ItemTreeService;
}(TreeService));
export { ItemTreeService };
var NodeState = /** @class */ (function () {
    function NodeState() {
        this.opened = false;
        this.disabled = false;
        this.selected = false;
        this.checked = false;
    }
    return NodeState;
}());
export { NodeState };
var ItemTreeNode = /** @class */ (function (_super) {
    __extends(ItemTreeNode, _super);
    function ItemTreeNode(rec) {
        var _this = _super.call(this, rec) || this;
        _this.state = new NodeState();
        _this.children = [];
        _this.li_attr = {};
        _this.a_attr = {};
        return _this;
    }
    return ItemTreeNode;
}(TreeNode));
export { ItemTreeNode };
//# sourceMappingURL=item-tree.service.js.map